import React from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import Button from "../../../elements/CustomButton/CustomButton";
import isMissingExpenseOrInvoice from "../PaymentList/isMissingExpenseOrInvoice";

const toolTipClient = (
  <Tooltip id="tooltipClient">
    <p>
      <FormattedMessage id="ids_goToClient" />
    </p>
  </Tooltip>
);

const toolTipSupplier = (
  <Tooltip id="toolTipSupplier">
    <p>
      <FormattedMessage id="ids_goToSupplier" />
    </p>
  </Tooltip>
);

const toolTipCollaborator = (
  <Tooltip id="toolTipCollaborator">
    <p>
      <FormattedMessage id="ids_goToCollaborator" />
    </p>
  </Tooltip>
);

const computeText = (
  bankTransactionLines,
  ecritureLines,
  status,
  intl,
  history
) => {
  let text = "";

  let categoryText = "";
  let tiersNameText = "";
  let countText = "";
  let taxesText = "";
  let iconTiers = "";

  let isTaxes = false;
  for (const ecritureLine of ecritureLines) {
    if (ecritureLine.category && ecritureLine.category.categoryFamily && ecritureLine.category.categoryFamily.ids === "ids_taxes")
      isTaxes = true;
  }

  if (
    bankTransactionLines &&
    bankTransactionLines[0] &&
    bankTransactionLines[0].category
  ) {
    const family = bankTransactionLines[0].category.categoryFamily;
    // console.log("bankTransactionLines[0]", bankTransactionLines[0]);

    if (
      family &&
      (family.clientCategoryForEcriture ||
        family.supplierCategoryForEcriture ||
        family.collaboratorCategoryForEcriture)
    ) {

      // console.log("try text");
      const tiersId =
        bankTransactionLines[0].tiers &&
        bankTransactionLines[0].tiers.id;

      const catName = bankTransactionLines[0].category.name;
      let tiersName = bankTransactionLines[0].tiers
        ? bankTransactionLines[0].tiers.name
        : "";

      if (ecritureLines !== undefined) {
        const tiersFromEcriture = isMissingExpenseOrInvoice(ecritureLines);
        if (tiersFromEcriture && tiersFromEcriture.tiers && tiersFromEcriture.tiers.name !== "")
          tiersName = tiersFromEcriture.tiers.name;
      }

      let historyPush;
      let toolTip;

      if (family && family.clientCategoryForEcriture) {
        historyPush = `/clients/${tiersId}/show`;
        toolTip = toolTipClient;
      }
      else if (family && family.supplierCategoryForEcriture) {
        historyPush = `/suppliers/${tiersId}/show`;
        toolTip = toolTipSupplier;
      }
      else if (family && family.collaboratorCategoryForEcriture) {
        historyPush = `/collaborators/${tiersId}/show`;
        toolTip = toolTipCollaborator;
      }

      iconTiers = (
        <OverlayTrigger placement="top" overlay={toolTip}>
          <Button icon wd bsStyle="primary"
            style={{
              minWidth: "inherit",
              border: "none",
              padding: "0px 0px 0px 0px",
              margin: "-2px 1px 0px 0px",
              borderRadius: "100%"
            }}
            onClick={e => {
              e.stopPropagation();

              if (historyPush !== "") {
                history.push(historyPush);
              }
            }}
            className="text-primary fa-lg fa fa-user"
          // style={{ paddingRight: "0px" }}
          />
        </OverlayTrigger>
      );

      categoryText = catName;
      tiersNameText = tiersName;
      text = catName + " - " + tiersName;

    } else {

      for (const line of bankTransactionLines) {
        const family = line.category.categoryFamily;

        if (
          categoryText === "" &&
          family &&
          (family.clientCategoryForEcriture ||
            family.supplierCategoryForEcriture ||
            family.collaboratorCategoryForEcriture)
        ) {

          const tiersId =
            bankTransactionLines[0].tiers &&
            bankTransactionLines[0].tiers.id;

          const catName = line.category.name;
          let tiersName = line.tiers
            ? line.tiers.name
            : "";

          if (ecritureLines !== undefined) {
            const tiersFromEcriture = isMissingExpenseOrInvoice(ecritureLines);
            if (tiersFromEcriture && tiersFromEcriture.tiers && tiersFromEcriture.tiers.name !== "")
              tiersName = tiersFromEcriture.tiers.name;
          }

          let historyPush;
          let toolTip;

          if (family && family.clientCategoryForEcriture) {
            historyPush = `/clients/${tiersId}/show`;
            toolTip = toolTipClient;
          }
          else if (family && family.supplierCategoryForEcriture) {
            historyPush = `/suppliers/${tiersId}/show`;
            toolTip = toolTipSupplier;
          }
          else if (family && family.collaboratorCategoryForEcriture) {
            historyPush = `/collaborators/${tiersId}/show`;
            toolTip = toolTipCollaborator;
          }

          iconTiers = (
            <OverlayTrigger placement="top" overlay={toolTip}>
              <Button icon wd bsStyle="primary"
                style={{
                  minWidth: "inherit",
                  border: "none",
                  padding: "0px 0px 0px 0px",
                  margin: "-3px 1px 0px 0px",
                  borderRadius: "66%"
                }}
                onClick={e => {
                  e.stopPropagation();

                  if (historyPush !== "") {
                    history.push(historyPush);
                  }
                }}
                className="text-primary fa-lg fa fa-user"
              // style={{ paddingRight: "0px" }}
              />
            </OverlayTrigger>
          );

          categoryText = catName;
          tiersNameText = tiersName;
          text = catName + " - " + tiersName;
        }
      }

      if (categoryText === "") {
        text = bankTransactionLines[0].category.name;
        categoryText = bankTransactionLines[0].category.name;
      }
    }

    if (bankTransactionLines.length > 1) {
      countText = " (+" + (bankTransactionLines.length - 1) + ")";
      text = text + countText;
    }

    if (isTaxes) {
      taxesText = " (+" + intl.formatMessage({ id: "ids_taxes" }) + ")";
      text = text + taxesText;
    }

  } else if (status === "AQUALIFIER") {
    categoryText = intl.formatMessage({ id: "AQUALIFIER" });
    text = categoryText;

    // RED '?'
    //text = <div><span>{text}</span><span style={{color: "Red"}}> ?</span></div>;

    // RED TEXT
    //text = <div className="text-danger"><span>{text}</span></div>;
  } else {
    //text = "brancher la qualification auto ";
    categoryText = " ";
    text = categoryText;
  }

  const retText = (
    <div>
      {categoryText}
      {tiersNameText !== "" ? " - " : ""}
      {countText === "" && tiersNameText !== "" ? iconTiers : ""}
      {tiersNameText !== "" ? tiersNameText : ""}
      {countText !== "" ? countText : ""}
      {taxesText !== "" ? taxesText : ""}

    </div>
  );

  const ret = {
    text: text,
    divText: retText

  }
  return ret;
};

export default computeText;
